import { IconCircleCheck } from '@tabler/icons-react'

interface SetupFooterProps {
  title: string
  items: string[]
}

export const SetupFooter: React.FC<SetupFooterProps> = ({ title, items }) => {
  return (
    <div className="flex h-full items-end">
      <div className="mt-8 space-y-4 text-sm">
        <h2 className="mb-6 text-lg font-bold text-gray-700">{title}</h2>
        {items.map((item, index) => (
          <div
            key={index}
            className={`flex items-start gap-x-2 text-gray-700 ${
              index === 0 ? '' : ''
            }`}
          >
            <IconCircleCheck className="min-h-5 min-w-5 max-w-5 max-h-5 text-green-500" />
            <span className="text-base font-medium">{item}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
